export default "__VITE_ASSET__dqs$_DFa__"